import ReportPage from './ReportPage'

export default function ReportLojasVendaPremiada({className = ''}: {className?: string}) {
  return <ReportPage type='lojas_sem_compra_12_meses' className={className} />
}
